import type { InterventionsListTableRowActionsProps } from "./interventions-list-table-row-actions.type";

import ListTableRowActions from "@/modules/list-table-row-actions";

import InterventionsListTableRowActions from "./interventions-list-table-row-actions.component";

const InterventionsListTableRowActionsWrapper = (
  props: InterventionsListTableRowActionsProps
) => {
  return (
    <ListTableRowActions>
      <InterventionsListTableRowActions {...props} />
    </ListTableRowActions>
  );
};

export default InterventionsListTableRowActionsWrapper;
